import React from 'react'

interface CareerSearchResultsProps {
  title: string;
  children: JSX.Element
}

const CareerSearchResults = ({ title, children }: CareerSearchResultsProps) => (
  <div className="grid__col grid__col--3-4">
    <p className="title__h3">{title}</p>
    <div className="grid grid--gutters-md grid--v-top">
      <div className="grid__col grid__col--1-1" />
    </div>
    <div className="grid grid--gutters-md grid--v-top">
      <div className="grid__col grid__col--1-1">
        {children}
      </div>
    </div>
  </div>
)

export default CareerSearchResults